export default {
    layout: {
        loading: 'ກຳລັງເທຣດ',
        trading: 'ກຳລັງເທຣດ'
    },
    footer: {
    },
    menu: {
        home: 'ໜ້າຫຼັກ',
        staking: 'ມາຕຣິກ',
        port: 'PORT',
        internet: 'ເຄືອຂ່າຍ',
        me: 'ຂອງຂ້ອຍ',
    },
    header: {
        selectLang: 'ເລືອກພາສາ',
        close: 'ປິດ',
        trading: 'ຊື້ຂາຍ',
        dashboard: 'ກະດານຄວບຄຸມ',
        subscribeMatrix: 'ສະໝັກແມັດຣິກ',
        portTaskCenter: 'ສູນວຽກ PORT',
        network: 'ເຄືອຂ່າຍ',
        apiBinding: 'API ຜູກມັດ',
        gridTree: 'ຕົ້ນໄມ້ Grid',
        account: 'ບັນຊີ',
        documents: 'ເອກະສານ & ປື້ມຂາວ',
        personalCenter: 'ສູນສ່ວນຕົວ',
        language: 'ພາສາ'
    },
    home: {
        recently1:'ຊຸມຊົນ',
        staticrewares: 'ຄົງທີ່',
        recentlyName: 'ບັນຊີ',
        recentlyInfo: 'ລາຍລະອຽດລາຍຮັບ',
        dataUpdate: 'ປັບປຸງຂໍ້ມູນ',
        realtime: 'ເວລາຈິງ·BSC',
        totalRevenue: 'ລາຍຮັບລວມ (USDT)',
        today: 'ມື້ນີ້',
        totalTradingVolume: 'ປະລິມານຊື້ຂາຍລວມ',
        todayEarn: 'ລາຍຮັບມື້ນີ້',
        share: 'ແບ່ງປັນໃຫ້ໝູ່',
        shareDesc: 'ໂຊວລາຍຮັບ ແລະ ເຊີນເພື່ອຮັບລາງວັນ',
        directReferrals: 'ຈຳນວນຜູ້ອ້າງອີງຕົງ',
        teamMembers: 'ຈຳນວນທີມ',
        thisWeek: 'ອາທິດນີ້',
        copy: 'ຄັດລອກ',
        recently: 'ລາຍຮັບຫຼ້າສຸດ',
        netIncome: 'ລາຍຮັບສຸດທິ',
        dailyAverage: 'ຄ່າສະເລ່ຍປະຈຳມື້',
        quantitativeIncome: 'ລາຍຮັບປະລິມານ',
        recommend: 'ແນະນຳ',
        port: 'PORT',
        bonus: 'ໂບນັດ',
        all: 'ທັງໝົດ',
        todayTitle: 'ມື້ນີ້',
        loadingMore: 'ໂຫຼດເພີ່ມ',
        recommendBonus: 'ລາງວັນແນະນຳ',
        portTaskPassed: 'ວຽກ PORT ຜ່ານ',
        myProfit: 'ກຳໄລຂອງຂ້ອຍ',
        earningOnBitDeep: 'ຂ້ອຍຮັບລາຍຮັບໃນ BitDeep',
        totalRevenueUsdt: 'ລາຍຮັບລວມ · USDT',
        consecutiveDays: 'ຈຳນວນມື້ຕິດຕໍ່',
        scanToJoin: 'ສະແກນເພື່ອເຂົ້າຮ່ວມ',
        uid: 'UID',
        referralBonus: 'ລາງວັນອ້າງອີງ',
        shareTo: 'ແບ່ງປັນໄປ',
        eachReferral: 'ລາງວັນແບ່ງປັນ',
        screenshotAndShare: 'ຖ່າຍຮູບແລະແບ່ງປັນ',
        saveShareEarn: 'ບັນທຶກ · ແບ່ງປັນ · ຮັບລາງວັນ',
        period: 'ຊ່ວງເວລາ',
        netProfit: 'ກຳໄລສຸດທິ',
        quantReward: 'ລາງວັນປະລິມານ',
        dailyBonus: 'ລາງວັນ PORT ປະຈຳມື້',
        close: 'ປິດ',
        permission: 'ສິດ',
        onlyEnable: 'ເປີດເທົ່ານັ້ນ',
        enterBitgetUid: 'ໃສ່ BITGET UID',
        slogan: 'ຄຳຂວັນ',
        document: 'ເອກະສານ',
        days: 'ມື້',
        taskText: 'ວຽກ',
        minutes: 'ນາທີ',
        decentralizedPortTech: 'ໂຄງສ້າງເທັກໂນໂລຊີ PoRT ການກະຈາຍສູນ, ເສດຖະກິດໂທເຄັນ BGB, ແລະ ແມັດຣິກສົ່ງເສີມຄູ່.',
        auditReport: 'ບົດລາຍງານກວດສອບ',
        faqSupport: 'ຄຳຖາມທົ່ວໄປ & ສະຫນັບສະຫນູນ',
        telegram: 'Telegram',
        piece: 'ສ່ວນ',
        faq: 'ຄຳຖາມທົ່ວໄປ',
       faq1: 'ເຊື່ອມຕໍ່ Bitget API ແນວໃດ?',
        faq1Desc: 'ເຂົ້າ Bitget Exchange → ການຕັ້ງຄ່າ → ການຈັດການ API ເພື່ອຮັບ API Key ແລະ Secret. ເປີດສະເພາະສິດ Spot Trading; ຫ້າມເປີດສິດການຖອນ. ວາງລະຫັດໃສ່ BitDeep DApp. ເມື່ອການເທຣດທົດສອບ 1 USDT ສຳເລັດ, ການເຊື່ອມຕໍ່ຈະຖືກເປີດໃຊ້ງານ.',
        faq2: 'PoRT (ຫຼັກຖານການເທຣດແທ້) ແມ່ນຫຍັງ?',
        faq2Desc: 'PoRT ແມ່ນກົນໄກຫຼັກຂອງ "ການເທຣດຄືການຂຸດ". ທຸກໆມື້, ລະບົບໃຊ້ Bitget API ເພື່ອຊື້-ຂາຍໄວຂອງຫຼຽນທີ່ກຳນົດ (ເຊັ່ນ BGB) ໂດຍອັດຕະໂນມັດ. ເມື່ອປະລິມານເທຣດເກີນ Stake × 50%, ລະບົບຢືນຢັນແລ້ວຈ່າຍລາງວັນປະຈໍາວັນ.',
        faq3: 'ຕ້ອງເຝົ້າເບິ່ງດ້ວຍຕົນເອງທຸກວັນບໍ?',
        faq3Desc: 'ບໍ່ຕ້ອງ. ຫຼັງເຊື່ອມ API ແລ້ວ, ລະບົບຈະສຳເລັດໜ້າວຽກເທຣດໂດຍອັດຕະໂນມັດໃນຫນ້າຕ່າງ 24 ຊົ່ວໂມງ. ບໍ່ຕ້ອງປະຕິບັດດ້ວຍຕົນເອງ; ກວດສອບໄດ້ທີ່ເມນູ PoRT.',
        faq4: 'ALPHA ແລະ SIGMA ແຕກຕ່າງກັນແນວໃດ?',
        faq4Desc: 'ALPHA (ເລີ່ມຕົ້ນ): Stake 500 USDT, ຜົນຕອບແທນ 0.3–1.3% ຕໍ່ມື້, ຊື້ໄດ້ພຽງ 1 ຊຸດ. SIGMA (ໂປຣ): Stake 1,000 USDT, ຜົນຕອບແທນ 0.6–1.6% ຕໍ່ມື້, ຊື້ໄດ້ສູງສຸດ 5 ຊຸດ.',
        faq5: 'ເງິນຂອງຂ້ອຍປອດໄພບໍ? ແພລດຟອມສາມາດແຕະຕ້ອງເງິນຂອງຂ້ອຍໄດ້ບໍ?',
        faq5Desc: 'ເງິນຂອງທ່ານ 100% ຍັງຄົງຢູ່ໃນບັນຊີ Bitget ຂອງທ່ານເອງ. API ໃຫ້ສິດອ່ານ ແລະ ເທຣດ spot ເທົ່ານັ້ນ; ລະບົບບໍ່ສາມາດຖອນ ຫຼື ໂອນເງິນຕົ້ນໃດໆ ໄດ້.',
        faq6: 'ລາຍຮັບປະຈໍາວັນຖືກຊໍາລະເມື່ອໃດ?',
        faq6Desc: 'ຫຼັງຈາກ PoRT ຢືນຢັນສຳເລັດ, ການຊໍາລະຈະເຮັດໃນມື້ຖັດໄປ. ລະບົບປ່ອຍລາງວັນຄູ່ໂດຍອັດຕະໂນມັດ: ລາຍຮັບ USDT ແລະ ຄະແນນ 10x Deep.',
        faq7: 'Scout Bonus (ລາງວັນແນະນຳໂດຍກົງ) ຄຳນວນແນວໃດ?',
        faq7Desc: 'ສຳລັບແຕ່ລະບັນຊີທີ່ໃຊ້ງານທີ່ທ່ານແນະນຳໂດຍກົງ, ທ່ານໄດ້ຮັບລາງວັນຄົງທີ່ປະຈໍາວັນ: 1 USDT/ມື້ ສຳລັບການແນະນຳ ALPHA (500 USDT), 2 USDT/ມື້ ສຳລັບການແນະນຳ SIGMA (1,000 USDT), ຈົນກວ່າຮອບຂອງບັນຊີນັ້ນສິ້ນສຸດ.',
        faq8: 'ຂຶ້ນລະດັບ (D1–D7) ແນວໃດ?',
        faq8Desc: 'ຂຶ້ນລະດັບໂດຍອີງໃສ່ປະລິມານລວມຂອງເຂດນ້ອຍ. ຕົວຢ່າງ: D1 ຕ້ອງການ 2,000 USDT, D3 ຕ້ອງການ 15,000 USDT, D7 (ສູງສຸດ) ຕ້ອງການ 3,000,000 USDT. ລະດັບສູງຂຶ້ນ, ໂບນັດຄວາມຕ່າງລະດັບກໍ່ສູງຂຶ້ນ (D7 ສູງສຸດ 7 USDT/ຄົນ/ມື້).',
        faq9: 'ໜຶ່ງຮອບແມ່ນຈັກວັນ? ໝົດອາຍຸແລ້ວເຮັດແນວໃດ?',
        faq9Desc: 'ໜຶ່ງຮອບແມ່ນ 28 ມື້. ຫຼັງຈາກຮອບສິ້ນສຸດ ທ່ານສາມາດເລືອກສືບຕໍ່ Stake ໄດ້; ລາງວັນຖືກຈ່າຍຕາມຜົນການຢືນຢັນ PoRT ປະຈໍາວັນຕົວຈິງ (ຜົນຕອບແທນປ່ຽນແປງ).',
        faq10: 'ມີຄ່າທຳນຽມໃນການຖອນບໍ?',
        faq10Desc:'ການຖອນບໍ່ມີຄ່າທຳນຽມ. ແພລດຟອມສົ່ງຄ່າທຳນຽມການຖອນກັບເຂົ້າສະນຸບ ເພື່ອເພີ່ມຄວາມໜາ LP, ສ້າງວົງຈອນທີ່ດີ.',
        bigArea: 'ເຂດໃຫຍ່',
        smallArea: 'ເຂດນ້ອຍ',
        enterWithdrawAmount: 'ໃສ່ຈຳນວນຖອນ',
        all: 'ທັງໝົດ',
        available: 'ສາມາດໃຊ້ໄດ້',
        totalAmount: 'ຈຳນວນລວມ',
        confirmWithdraw: 'ຢືນຢັນການຖອນ',
        withdrawRecord: 'ບັນທຶກການຖອນ',
        withdrawn: 'ຖອນແລ້ວ',
        quickStartGuide:'ຄູ່ມືເລີ່ມໄວ',
        whitepaperGuide:'ປື້ມຂາວ & ຄູ່ມື',
        whitepaper:'ປື້ມຂາວ',
        downloadPdf:'ດາວໂຫຼດ'
},
staking: {
    selectPackage: 'ສະໝັກແມັດຣິກ',
    alpha: 'ALPHA',
    beginner: 'ເລີ່ມຕົ້ນ',
    sigma: 'SIGMA',
    professional: 'ມືອາຊີບ',
    popular: 'ນິຍົມທີ່ສຸດ',
    dailyReturn: 'ລາງວັນໜ້າວຽກ',
    teamDepth: 'ຄວາມເລິກຂອງທີມ',
    limitPurchase: 'ຈຳກັດການຊື້',
    layer: 'ຊັ້ນ',
    copy: 'ສ່ວນ',
    autoRenew: 'ຕໍ່ອາຍຸອັດຕະໂນມັດ',
    autoReinvest: 'ອັດຕາດອກເບ້ຍຕໍ່ອາຍຸອັດຕະໂນມັດ',
    subscribeAlpha: 'ສະໝັກ Alpha',
    subscribeSigma: 'ສະໝັກ Sigma',
    stakedAmount: 'ເງິນຄໍ້າປະກັນ',
    stakedAmount2: 'ຊ່ວງເວລາ',
    stakedAmount3: 'ລາຍຮັບສະສົມ',
    stakingTime: 'ເວລາເຂົ້າຮ່ວມ',
    maturityTime: 'ເວລາຫມົດອາຍຸ',
    redeem: 'ໄຖ່',
    renew: 'ຕໍ່ອາຍຸ',
    autoRenewActive: 'ຕໍ່ອາຍຸອັດຕະໂນມັດແລ້ວ',
    autoRenewInactive: 'ບໍ່ໄດ້ຕໍ່ອາຍຸອັດຕະໂນມັດ',
    smartContract: 'ສັນຍາອັດສະຫຼາດຈັດການ, ເງິນຄໍ້າປະກັນ 28 ມື້, ຫມົດອາຍຸແລ້ວຈຶ່ງປົດລັອກ.',
     alter2:'ຖ້າສັນຍາໝົດອາຍຸແລ້ວ, ກະລຸນາຕໍ່ອາຍຸໃໝ່.',
},
me: {
    account: 'ບັນຊີ',
    my: 'ຂອງຂ້ອຍ',
    staked: 'ເຂົ້າຮ່ວມແລ້ວ',
    staked1:'ເງິນຄໍ້າປະກັນ',
    points: 'ຄະແນນ',
    consecutive: 'ຈຳນວນມື້ຕິດຕໍ່',
    withdraw: 'ຖອນ',
    language: 'ພາສາ',
    simplifiedChinese: 'ຈີນງ່າຍ',
    disconnectWallet: 'ຕັດການເຊື່ອມກະເປົາ',
    level: 'ລະດັບ',
    joinDate: 'ວັນເຂົ້າຮ່ວມ',
    bdId: 'BD-ID'
},
bindapi: {
    apiBinding: 'API ຜູກມັດ',
    bindDesc: 'ຜູກ API ຂອງທ່ານເພື່ອອະນຸຍາດການຊື້ຂາຍປະລິມານ',
    apiKey: 'API Key',
    apiSecret: 'API Secret',
    exchange: 'ການແລກປ່ຽນ',
    futures: 'ສັນຍາ',
    spot: 'ຕະຫຼາດທັນທີ',
    readOnly: 'ອ່ານເທົ່ານັ້ນ',
    bind: 'ຜູກ',
    riskNote: 'API Key ໃຊ້ສຳລັບການຊື້ຂາຍຂໍ້ມູນ ບໍ່ເກັບຂໍ້ມູນອ່ອນໄຫວ',
    apiConnection: 'API ເຊື່ອມຕໍ່',
    bindExchangeApi: 'ຜູກ API ການແລກປ່ຽນ',
    bitDeepRead: 'BitDeep ອ່ານຄຳສັ່ງຈາກບັນຊີ CEX ເພື່ອຢືນຢັນການຊື້ຂາຍຈິງ (PoRT).',
    noWithdraw: 'ພວກເຮົາບໍ່ເຂົ້າຖືກການຖອນຂອງທ່ານ.',
    securityTip: 'ຄຳແນະນຳຄວາມປອດໄພ·ກະລຸນາອ່ານຢ່າງລະມັດລະວັງ',
    close: 'ປິດ',
    withdraw: 'ຖອນ',
    permission: 'ສິດ',
    onlyEnable: 'ເປີດເທົ່ານັ້ນ',
    spotTrading: 'ຊື້ຂາຍຕະຫຼາດທັນທີ',
    read: 'ອ່ານ',
    recommendedPartner: 'ພາກສ່ວນແນະນຳ',
    zeroFee: '0% ຄ່າທຳນຽມ',
    activated: 'ເປີດໃຊ້ແລ້ວ',
    classicAccount: 'ບັນຊີຄລາສສິກ',
    unifiedAccount: 'ບັນຊີຮວມ',
    bindBitgetApi: 'ຜູກ Bitget API',
    upcoming: 'ຈະມາໃນໄວໆນີ້',
    underAudit: 'ກຳລັງກວດສອບ',
    expected: 'ຄາດວ່າ'
},
port: {
    portTaskCenter: 'ສູນວຽກ PORT',
    dailyTask: 'ວຽກປະຈຳມື້',
    verify: 'ກວດສອບ',
    completed: 'ສຳເລັດແລ້ວ',
    incomplete: 'ບໍ່ສຳເລັດ',
    verifyStandard: 'ມາດຕະຖານການກວດສອບ',
    tradingVolume: 'ປະລິມານຊື້ຂາຍ',
    today: 'ມື້ນີ້',
    deadline: 'ກຳນົດເວລາ',
    reward: 'ລາງວັນ',
    startVerify: 'ເລີ່ມກວດສອບ',
    verifying: 'ກຳລັງກວດສອບ',
    verified: 'ກວດສອບແລ້ວ',
    insufficient: 'ບໍ່ພຽງພໍ',
    viewDetails: 'ເບິ່ງລາຍລະອຽດ',
    taskList: 'ລາຍຊື່ວຽກ',
    allTasks: 'ວຽກທັງໝົດ',
    completedTasks: 'ສຳເລັດແລ້ວ',
    pendingTasks: 'ລໍຖ້າສຳເລັດ',
    proofOfRealTrading: 'ຫຼັກຖານການຊື້ຂາຍຈິງ',
    todayTask: 'ວຽກມື້ນີ້',
    todayStaticIncome: 'ລາງວັນພາລະກິດຂອງມື້ນີ້',
    points: 'ຄະແນນ',
    todayWindowClosesAt: 'ປິດຊ່ອງມື້ນີ້ເວລາ',
    checkTaskStatus: 'ກວດສອບສະຖານະວຽກ',
    teamProgress: 'ຄວາມຄືບໜ້າຂອງທີມ·ມື້ນີ້',
    realtimePortCompletion: 'ສະຖານະ PORT ເວລາຈິງ',
    completedText: 'ສຳເລັດແລ້ວ',
    pendingText: 'ລໍຖ້າສຳເລັດ',
    realtimeApiValidationFlow: 'ເວລາຈິງ · API · ການກວດສອບ',
    rewardRemark1:'Global Dividend',
        rewardRemark2:'Level-Differential Bonus',
        rewardRemark3:'Scout Bonus',
        rewardRemark4:'Task Reward',
        rewardRemark5:'PoRT Task Success',
},
internet: {
    network: 'ເຄືອຂ່າຍ',
    treeBrowser: 'ເບິ່ງໂຄງສ້າງເປັນຕົ້ນໄມ້',
    searchAddress: 'ຄົ້ນຫາທີ່ຢູ່ 0x... ຫຼື BD-ID',
    totalTradingVolume: 'ປະລິມານຊື້ຂາຍລວມ',
    members: 'ສະມາຊິກ',
    networkStructure: 'ໂຄງສ້າງເຄືອຂ່າຍ',
    allLevels: 'ທຸກລະດັບ',
    addRemark: 'ເພີ່ມຂໍ້ຄວາມ',
    enterRemark: 'ກະລຸນາໃສ່ຂໍ້ຄວາມ',
    cancel: 'ຍົກເລີກ',
    confirm: 'ຢືນຢັນ',
    alert1:'Share Performance',
    alert2:'Team Performance',
    alert3:'Task Status',
},
withdraw: {
    withdraw: 'ຖອນ',
    usdtAsset: 'ຊັບສິນ USDT',
    withdrawAmount: 'ຈຳນວນຖອນ',
    availableBalance: 'ຍອດເຫຼືອທີ່ໃຊ້ໄດ້',
    fee: 'ຄ່າທຳນຽມ',
    actualArrival: 'ເຂົ້າບັນຊີຈິງ',
    submit: 'ສົ່ງ',
    withdrawSuccess: 'ຖອນສຳເລັດ',
    withdrawFailed: 'ຖອນລົ້ມເຫຼວ',
    processing: 'ກຳລັງດຳເນີນ',
    completed: 'ສຳເລັດແລ້ວ',
    withdrawHistory: 'ປະຫວັດການຖອນ'
},
popup: {
    taskUnfinished: 'ວຽກບໍ່ສຳເລັດ',
    taskUnfinishedDesc: 'ຂໍ້ມູນຊື້ຂາຍບໍ່ຖືກຕາມມາດຕະຖານ PoRT ມື້ນີ້',
    todayTradingVolume: 'ປະລິມານຊື້ຂາຍມື້ນີ້',
    remaining: 'ຍັງຂາດ',
    toComplete: 'ເພື່ອສຳເລັດວຽກມື້ນີ້',
    tradingVolumeThreshold: '',
    deadline: 'ເຫຼືອເວລາກ່ອນວຽກສິ້ນສຸດ',
    tryAgain: 'ລອງອີກຄັ້ງ',
    goTrade: 'ໄປຊື້ຂາຍ',
    taskCompleted: 'ການກວດສອບວຽກຜ່ານ',
    taskCompletedDesc: 'ຫຼັກຖານ PoRT ມື້ນີ້ຖືກບັນທຶກໃນ blockchain ສຳເລັດແລ້ວ',
    rewardIssued: 'ລາງວັນຖືກຈ່າຍ',
    complete: 'ສຳເລັດ',
    shareTitle: 'ແບ່ງປັນການເຊີນ',
    shareDesc: 'ເຊີນໝູ່ມາສະໝັກ, ທັງສອງຝ່າຍຈະໄດ້ຮັບລາງວັນ',
    referralLink: 'ລິ້ງເຊີນ',
    qrCode: 'QR Code',
    copyLink: 'ຄັດລອກລິ້ງ',
    notask:'ມື້ນີ້ບໍ່ມີວຽກ',
    notaskDesc:'ຂະນະນີ້ບໍ່ມີວຽກການເທຣດ PoRT ທີ່ລໍຖ້າດໍາເນີນການ',
}
};